import { Container, Tab, Tabs, useTheme } from '@mui/material';
import Layout from '@/components/layout/main-layout';
import LocationsPanel from '@/components/admin/locations/locations-panel';
import ScrollToTop from '@/components/ui/scroll-to-top';
import ResponsiveTypography from '@/components/ui/responsive-typography';
import { useTranslation } from 'react-i18next';
import { useCallback, useState } from 'react';
import CompaniesPanel from '@/components/admin/companies/company-list';

const AdminMainPage: React.FC = () => {
  const { t } = useTranslation();

  const theme = useTheme();

  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = useCallback(
    (_: React.ChangeEvent<unknown>, newValue: number) => {
      setTabValue(newValue);
    },
    []
  );

  const firstTranslationKey = 'admin_dashboard';

  return (
    <Layout firstTranslationKey={firstTranslationKey}>
      <Container
        maxWidth={'md'}
        sx={{
          pt: 2,
          marginTop: 1,
          position: 'relative'
        }}
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          centered
          TabIndicatorProps={{
            style: { backgroundColor: theme.palette.text.primary }
          }}
        >
          <Tab
            label={
              <ResponsiveTypography
                sx={{
                  color: theme.palette.text.primary
                }}
              >
                {t('companies_management')}
              </ResponsiveTypography>
            }
          />

          <Tab
            label={
              <ResponsiveTypography
                sx={{
                  color: theme.palette.text.primary
                }}
              >
                {t('location_management')}
              </ResponsiveTypography>
            }
          />
        </Tabs>
        {tabValue === 0 && <CompaniesPanel />}
        {tabValue === 1 && <LocationsPanel />}
      </Container>
      <ScrollToTop />
    </Layout>
  );
};

export default AdminMainPage;
